import { createFeatureSelector } from '@ngrx/store';
import { SEO_FEATURE_NAME } from './feature-name';

export const getStoryblokSEOState = createFeatureSelector(SEO_FEATURE_NAME);
